import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { setChatOpen, setDrawerOpen } from '../../state/uiSlice';
import { isSheetLayout } from './util';

/** An absolute URL leaves the app; everything else is a route inside it. */
const isExternal = (to) => /^https?:\/\//i.test(String(to || ''));

/**
 * Places the agent pointed at — suggested funds, stocks, models, a saved
 * screen — as links the reader can open, rather than names they have to go and
 * search for.
 *
 * On a phone the dock and the drawer cover the whole page, so following a link
 * with them open would change a screen nobody can see. There the sheet closes
 * as the link is followed; on a desktop it stays, because the panel sits beside
 * the page and the conversation is still wanted.
 */
export default function LinksCard({ message }) {
  const dispatch = useDispatch();
  const card = message?.card;
  const items = Array.isArray(card?.items) ? card.items.filter((it) => it && it.label) : [];
  if (!card || items.length === 0) return null;

  const uncover = () => {
    if (!isSheetLayout()) return;
    dispatch(setChatOpen(false));
    dispatch(setDrawerOpen(false));
  };

  return (
    <div className="cp-card cp-links">
      {card.title && <b className="cp-card-title">{card.title}</b>}
      <ul>
        {items.map((it, i) => {
          const body = (
            <>
              <span className="cp-link-main">
                <span className="cp-link-label">{it.label}</span>
                {it.sub && <span className="cp-link-sub">{it.sub}</span>}
              </span>
              <span className="cp-link-go" aria-hidden="true">→</span>
            </>
          );
          const key = `${it.to || it.label}-${i}`;
          if (!it.to) {
            return <li key={key}><span className="cp-link static">{body}</span></li>;
          }
          return (
            <li key={key}>
              {isExternal(it.to) ? (
                <a className="cp-link" href={it.to} target="_blank" rel="noopener noreferrer">{body}</a>
              ) : (
                <Link className="cp-link" to={it.to} onClick={uncover}>{body}</Link>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
